import BpmnModeler from "bpmn-js/lib/Modeler";
import "./styles/diagram-js.css";
import "bpmn-font/dist/css/bpmn-embedded.css";
import propertiesPanelModule from "bpmn-js-properties-panel";
import propertiesProviderModule from "bpmn-js-properties-panel/lib/provider/camunda";
import camundaModdleDescriptor from "camunda-bpmn-moddle/resources/camunda";
import "bpmn-js-properties-panel/dist/assets/bpmn-js-properties-panel.css";
import "./bpmn.css";
import { useEffect } from "react";
import BpmnColorPickerModule from "bpmn-js-color-picker";
import "bpmn-js/dist/assets/bpmn-font/css/bpmn-embedded.css";
import "bpmn-js-color-picker/colors/color-picker.css";
import resizeTask from "bpmn-js-task-resize/lib";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

const emptyBpmn = `<?xml version="1.0" encoding="UTF-8"?>
<bpmn2:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:bpmn2="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" id="sample-diagram" targetNamespace="http://bpmn.io/schema/bpmn" xsi:schemaLocation="http://www.omg.org/spec/BPMN/20100524/MODEL BPMN20.xsd"><bpmn2:process id="Process_191t89p" /><bpmndi:BPMNDiagram id="BPMNDiagram_1"><bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_191t89p" /></bpmndi:BPMNDiagram></bpmn2:definitions>`;

let modeler = null;

function Bpmn2() {
  useEffect(() => {
    modeler = new BpmnModeler({
      container: "#bpmnview",
      keyboard: {
        bindTo: window,
      },
      propertiesPanel: {
        parent: "#propview",
      },
      additionalModules: [
        propertiesPanelModule,
        propertiesProviderModule,
        BpmnColorPickerModule,
        resizeTask,
      ],
      taskResizingEnabled: true,
      moddleExtensions: {
        camunda: camundaModdleDescriptor,
      },
    });

    newBpmnDiagram();
  });

  const newBpmnDiagram = () => {
    openBpmnDiagram(localStorage.getItem("sen") || emptyBpmn);
  };

  const openBpmnDiagram = (xml) => {
    modeler.importXML(xml, (error) => {
      if (error) {
        return console.log("fail import xml");
      }

      var canvas = this.modeler.get("canvas");

      canvas.zoom("fit-viewport");
    });
  };

  const zoomIn = () => {
    modeler.get('zoomScroll').stepZoom(1);
  }
  const zoomOut = () => {
    modeler.get('zoomScroll').stepZoom(-1);
  }
  const zoomReset = () => {
    modeler.get('zoomScroll').reset();
  }

  const saveBpmnDiagram = () => {
    modeler.saveXML().then((xml) => {
      localStorage.setItem("sen", xml.xml);

      const element = document.createElement("a");
      const file = new Blob([xml.xml], {
        type: "text/plain",
      });
      element.href = URL.createObjectURL(file);
      element.download = "bpmn.xml";
      document.body.appendChild(element);
      element.click();
    });
  };

  const saveProgess = () => {
    modeler.saveXML().then((xml) => {
      localStorage.setItem("sen", xml.xml);
    });
  };

  const openNew = () => {
    confirmAlert({
      title: "Confirm to submit",
      message: "Your progress will be lost.",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            openBpmnDiagram(emptyBpmn);
            localStorage.setItem("sen", emptyBpmn);
          },
        },
        {
          label: "No",
          onClick: () => {
            return;
          },
        },
      ],
    });
  };

  const downloadBpmnDiagram = () => {
    modeler.saveSVG().then((svg) => {
      const element = document.createElement("a");
      const file = new Blob([svg.svg], {
        type: "text/plain",
      });
      element.href = URL.createObjectURL(file);
      element.download = "bpmn.svg";
      document.body.appendChild(element);
      element.click();
    });
  };

  const changeHandler = (e) => {
    const file = e.target.files[0];
    var reader = new FileReader();

    reader.onload = function (event) {
      openBpmnDiagram(event.target.result);
    };
    reader.readAsText(file);
  };

  return (
    <>
      <div id="bpmncontainer">
        <div
          id="propview"
          style={{
            width: "25%",
            height: "95vh",
            float: "right",
            overflowX: "auto",
          }}
        ></div>
        <div
          id="bpmnview"
          style={{ width: "75%", height: "98vh", float: "left" }}
        >
          <nav
            style={{
              width: "fit-content",
              marginLeft: "1rem",
            }}
          >
            <label
              htmlFor="filePicker"
              style={{
                background: "black",
                color: "white",
                padding: "5px 10px 8px 10px",
                borderRadius: "20px",
                marginRight: "10px",
              }}
            >
              Import XML
            </label>
            <input
              onChange={(e) => changeHandler(e)}
              type="file"
              accept="text/xml"
              id="filePicker"
              style={{ display: "none" }}
            />
            <button
              style={{
                marginRight: "10px",
                background: "black",
                color: "white",
                padding: "5px 10px",
                borderRadius: "20px",
              }}
              onClick={saveProgess}
            >
              Save Progress
            </button>
            <button
              style={{
                marginRight: "10px",
                background: "black",
                color: "white",
                padding: "5px 10px",
                borderRadius: "20px",
              }}
              onClick={saveBpmnDiagram}
            >
              Save XML
            </button>
            <button
              style={{
                marginRight: "10px",
                background: "black",
                color: "white",
                padding: "5px 10px",
                borderRadius: "20px",
              }}
              onClick={downloadBpmnDiagram}
            >
              Save SVG
            </button>

            <button
              style={{
                marginRight: "10px",
                background: "black",
                color: "white",
                padding: "5px 10px",
                borderRadius: "20px",
              }}
              onClick={openNew}
            >
              Open New
            </button>
            <button
              style={{
                marginRight: "10px",
                background: "black",
                color: "white",
                padding: "5px 10px",
                borderRadius: "20px",
              }}
              onClick={zoomIn}
            >
              Zoom In
            </button>
            <button
              style={{
                marginRight: "10px",
                background: "black",
                color: "white",
                padding: "5px 10px",
                borderRadius: "20px",
              }}
              onClick={zoomOut}
            >
              Zoom Out
            </button>
            <button
              style={{
                marginRight: "10px",
                background: "black",
                color: "white",
                padding: "5px 10px",
                borderRadius: "20px",
              }}
              onClick={zoomReset}
            >
              Zoom Reset
            </button>
          </nav>
        </div>
      </div>
    </>
  );
}

export default Bpmn2;
